var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    viewBox: "0 0 100 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 13.1353C16.6667 10.8436 18.5417 8.96859 20.8333 8.96859H87.5C89.7917 8.96859 91.6667 7.09359 91.6667 4.80192C91.6667 2.51025 89.7917 0.635254 87.5 0.635254H16.6667C12.0833 0.635254 8.33333 4.38525 8.33333 8.96859V54.8019H6.25C2.79167 54.8019 0 57.5936 0 61.0519C0 64.5103 2.79167 67.3019 6.25 67.3019H58.3333V54.8019H16.6667V13.1353ZM95.8333 17.3019H70.8333C68.5417 17.3019 66.6667 19.1769 66.6667 21.4686V63.1353C66.6667 65.4269 68.5417 67.3019 70.8333 67.3019H95.8333C98.125 67.3019 100 65.4269 100 63.1353V21.4686C100 19.1769 98.125 17.3019 95.8333 17.3019ZM91.6667 54.8019H75V25.6353H91.6667V54.8019Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.5c7dd830d0e9179690865abab65d1368.svg";
export { ForwardRef as ReactComponent };